import React from 'react';
import { SanitizedHtml } from './SanitizedHtml';


const massageListItems = (listItems = '') => {
  /**
   * @todo
   * better approach would be to validate/modify the text going into the RTE.
   */
  // strips <p>, <br>, <ul> and new lines. 
  listItems = listItems.replace(/(<[^>]?(p|ol|br).*?>)|\n/g, '');
  if (!listItems.match(/^<li>.*<\/li>$/g)) {
    listItems = `<li>${listItems}</li>`;
  }
  return listItems;
}

export const SimObjectives = ({leadin, items = ''}) => {
  return (
    <>
      {/* Offset */}
      <div className="col-md-1"></div>

      <div className="col-12 col-lg-7 offset-lg-1 mt-4 mt-lg-0">
        <div className="dinfos-sim__obj">
          <h3 className="dinfos-sim__obj-title">Objectives</h3>
          <div className="dinfos-sim__obj-leadin">
            {leadin}
          </div>
      
          <SanitizedHtml tag="ol" className="dinfos-sim__obj-list" content={massageListItems(items)} />
          {/* <ol className="dinfos-sim__obj-list">
            {items.map((obj, objIndex) => (
              <li key={objIndex}>{obj}</li>
            ))}
          </ol> */}
        </div>
      </div>

      <div className="col-12 col-lg-3">
        <h3 className="dinfos-sim__story-next-title">Resources<i className="fas fa-server"></i></h3>
        <div className="dinfos-sim__story-next-instr">Don't forget, the resources in the upper right corner will stay with you throughout the mission.</div>
        <button type="button" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action d-block mx-auto mx-lg-0" data-next-screen="true">Accept Mission</button>
      </div>

      {/* Offset */}
      <div className="col-lg-1"></div>
    </>
  )
}